//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import constant from '~/const';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      filters: {
        fromDate: '',
        toDate: '',
      },
      constant,
    };
  },

  computed: {
    ...mapState('statisticsTransactions', ['filterLists']),
    ...mapGetters('currencies', ['getP2PCurrencyByTitle']),
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions('statisticsTransactions', ['setFilters']),
  },
};
